<section class="wrapper">
  <section mat-dialog-title>
    <button mat-dialog-close mat-icon-button matTooltip="Close.">
      <mat-icon>close</mat-icon>
    </button>
    <h1>
      <mat-icon>view_list</mat-icon>
      {{title[4] | date: 'EEEE, MMMM d y'}} | {{title[3]}} | {{title[2] |
      currency : 'GBP' : 'symbol-narrow'}}
    </h1>
  </section>
  <section>
    @if (loading) {
      <mat-card class="loading">
        <mat-card-content>
          <mat-icon>autorenew</mat-icon>
          Loading...
        </mat-card-content>
      </mat-card>
    }

    <section mat-dialog-content>
      <mat-table #table [dataSource]="DataSource" class="mat-batch-table">
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef>Name</mat-header-cell>
          <mat-cell *matCellDef="let row">
            {{row.first_name | titlecase}} {{row.last_name | titlecase}}
            </mat-cell
            >
          </ng-container>
          <ng-container matColumnDef="item_count">
            <mat-header-cell *matHeaderCellDef>Item Count</mat-header-cell>
            <mat-cell *matCellDef="let row">{{row.order_details.itemCount}}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="price">
            <mat-header-cell *matHeaderCellDef>Price</mat-header-cell>
            <mat-cell *matCellDef="let row"
              >{{row.order_details.total/100 | currency : 'GBP' : 'symbol-narrow'}}</mat-cell
              >
            </ng-container>
            <ng-container matColumnDef="order_status">
              <mat-header-cell *matHeaderCellDef>Order Status</mat-header-cell>
              <mat-cell *matCellDef="let row">{{row.status | titlecase}}</mat-cell>
            </ng-container>
          </mat-table>
        </section>
        <section align="end" mat-dialog-actions>
          <button (click)="downloadCSV()" mat-button matTooltip="Download.">
            <mat-icon>file_download</mat-icon>
            @if (loading) {
              <mat-spinner diameter="24"></mat-spinner>
            }
            Download CSV
          </button>
        </section>
      </section>
    </section>
